module.exports = __webpack_public_path__ + "img/mrt_x_vision_plus.eefa176d.jpg";